type CompensationProfileForInitialTotalCompensation = {
  id?: string;
  isSnapshot?: boolean | null;
  updatedAt?: string | null;
};

function getUpdatedAtTimestamp(profile: CompensationProfileForInitialTotalCompensation) {
  if (!profile.updatedAt) return Number.POSITIVE_INFINITY;

  const timestamp = new Date(profile.updatedAt).getTime();
  return Number.isNaN(timestamp) ? Number.POSITIVE_INFINITY : timestamp;
}

export function getInitialTotalCompensationProfile<T extends CompensationProfileForInitialTotalCompensation>(
  compensationProfiles: T[]
) {
  if (compensationProfiles.length === 0) return undefined;
  if (compensationProfiles.length === 1) return compensationProfiles[0];

  const snapshots = compensationProfiles.filter((profile) => profile.isSnapshot);
  if (snapshots.length === 0) return undefined;

  return snapshots.reduce((earliestSnapshot, profile) =>
    getUpdatedAtTimestamp(profile) < getUpdatedAtTimestamp(earliestSnapshot) ? profile : earliestSnapshot
  );
}
